import { Link } from "react-router-dom";
import { siteContent } from "../../content/siteContent";
import { trackCtaClick } from "../../lib/analytics";

export function PrimaryCta() {
  const { cta } = siteContent;

  return (
    <section className="home-cta" aria-labelledby="home-cta-title">
      <div className="home-shell home-cta__layout">
        <div>
          <p className="home-eyebrow home-cta__eyebrow">{cta.eyebrow}</p>
          <h2 id="home-cta-title" className="home-cta__title">
            {cta.titleLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
          </h2>
        </div>
        <div className="home-cta__action">
          <p>{cta.text}</p>
          <Link className="home-button home-button--light" to={cta.button.href}
            reloadDocument onClick={() => trackCtaClick("final")}>
            {cta.button.label}
            <span aria-hidden="true">↗</span>
          </Link>
          <span>{cta.note}</span>
        </div>
      </div>
    </section>
  );
}
